import { Component } from '@angular/core'

@Component({
  selector: 'app-external-redirect',
  template: '',
  styles: [''],
  standalone: false,
})
export class ExternalRedirectComponent {
  constructor() {}
}
